import AuthUser from './auth-user.model';

export default class UserLogin extends AuthUser {
    public isValid(): any {
        return !!(this.username && this.password && this.emailIsValid() && this.password.length >= 6);
    }
    public formIsComplete(): any {
        return !!(this.username && this.password)
    }

    public emailIsValid(): any {
        return this.username ?
            this.username.indexOf("@") !== -1 ?
                this.username.split("@")[0] &&
                    this.username.split("@")[0].length &&
                    this.username.split("@")[1] &&
                    this.username.split("@")[1].length
                    ? true : false
                : false
            : false
    }
    public typeError(): any {
        if (!this.formIsComplete()) {
            return 'formIncomplete';
        } else if (!this.emailIsValid()) {
            return 'emailInvalid';
        } else if (!this.password || (this.password && this.password.length < 6)) {
            return 'passwordLengthInvalid';
        } else {
            return undefined;
        }
    }
}